export function backgroundFor(condition: string, now: Date = new Date()): string {
  const c = (condition ?? '').toLowerCase();
  const hour = now.getHours();
  const isNight = hour < 6 || hour >= 19;

  if (c.includes('thunder') || c.includes('storm'))
    return 'bg-gradient-to-b from-slate-900 via-slate-800 to-indigo-950';
  if (c.includes('snow'))
    return 'bg-gradient-to-b from-slate-700 via-slate-500 to-slate-300 text-slate-900';
  if (c.includes('rain') || c.includes('shower'))
    return 'bg-gradient-to-b from-slate-700 via-blue-900 to-slate-900';
  if (c.includes('fog') || c.includes('haze'))
    return 'bg-gradient-to-b from-slate-500 via-slate-400 to-slate-300 text-slate-900';
  if (c.includes('cloud') || c.includes('overcast'))
    return isNight
      ? 'bg-gradient-to-b from-slate-900 via-slate-800 to-slate-700'
      : 'bg-gradient-to-b from-sky-700 via-sky-500 to-slate-300';
  if (isNight) return 'bg-gradient-to-b from-indigo-950 via-blue-950 to-slate-900';
  return 'bg-gradient-to-b from-sky-500 via-sky-400 to-amber-200';
}
